var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"chip-wrap day",class:[_vm.border, _vm.bg, _vm.ftcolor, _vm.disabled],on:{"click":_vm.clickChip}},[_vm._t("chipname")],2)}
var staticRenderFns = []

export { render, staticRenderFns }